import React from "react"
import { Updater, Widget, fromJSX } from "widgets-for-react"
import { ProductApiResponseParsed, ProductSale } from "../productFormBlock.state"
import { valutaDisplay } from "../utils"

const ProductSaleLayout = (form: ProductSale) => {
  return <>
    <p className='donation__seperator title--s'>Totaal {valutaDisplay(form.price)}</p>
  </>
}

export const productSaleSegment = (form: ProductSale): Widget<Updater<ProductApiResponseParsed>> => {
  return fromJSX<Updater<ProductSale>>(_ => {
    return ProductSaleLayout(form)
  })
    .map<Updater<ProductApiResponseParsed>>(u => s0 => s0)
}
